/* businesses */
export const UPDATE_EVENT = "UPDATE_EVENT"
export const UPDATE_EVENT_SUCCESS = "UPDATE_EVENT_SUCCESS"
export const UPDATE_EVENT_ERROR = "UPDATE_EVENT_ERROR"
export const UPDATE_EVENT_CLEAN = "UPDATE_EVENT_CLEAN"
